import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Typography,
  Grid,
  Box,
} from '@mui/material';

interface AssessmentDialogProps {
  open: boolean;
  selectedItem: any;
  categories: Array<{ _id: string; name: string; isActive: boolean }>;
  difficultyLevels: string[];
  assessmentFormik: any;
  onClose: () => void;
}

export const AssessmentDialog: React.FC<AssessmentDialogProps> = ({
  open,
  selectedItem,
  categories,
  difficultyLevels,
  assessmentFormik,
  onClose,
}) => {
  const isEditMode = selectedItem && selectedItem._id;
  console.log(selectedItem)
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {isEditMode ? 'Edit' : 'Create'} Assessment
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          {/* <form id="assessment-form" onSubmit={assessmentFormik.handleSubmit}> */}
              <TextField
                fullWidth
                label="Assessment Title"
                variant="outlined"
                name="title"
                value={assessmentFormik.values.title}
                onChange={assessmentFormik.handleChange}
                onBlur={assessmentFormik.handleBlur}
                error={assessmentFormik.touched.title && Boolean(assessmentFormik.errors.title)}
                helperText={assessmentFormik.touched.title && assessmentFormik.errors.title}
                sx={{ mb: 2 }}
                required
              />
              <TextField
                fullWidth
                label="Description"
                variant="outlined"
                multiline
                rows={3}
                name="description"
                value={assessmentFormik.values.description}
                onChange={assessmentFormik.handleChange}
                onBlur={assessmentFormik.handleBlur}
                error={assessmentFormik.touched.description && Boolean(assessmentFormik.errors.description)}
                helperText={assessmentFormik.touched.description && assessmentFormik.errors.description}
                sx={{ mb: 2 }}
                required
              />
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    select
                    size="small"
                    label="Category"
                    name="category"
                    value={assessmentFormik.values.category}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.category && Boolean(assessmentFormik.errors.category)}
                    helperText={assessmentFormik.touched.category && assessmentFormik.errors.category}
                    variant="outlined"
                    required
                  >
                    {categories.map((category) => (
                      <MenuItem key={category._id} value={category._id}>{category.name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    select
                    size="small"
                    label="Difficulty"
                    name="difficulty"
                    value={assessmentFormik.values.difficulty}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.difficulty && Boolean(assessmentFormik.errors.difficulty)}
                    helperText={assessmentFormik.touched.difficulty && assessmentFormik.errors.difficulty}
                    variant="outlined"
                    required
                  >
                    {difficultyLevels.map((level) => (
                      <MenuItem key={level} value={level}>{level}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>

              <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>Assessment Configuration</Typography>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                  <TextField
                    fullWidth
                    label="Number of Questions"
                    type="number"
                    name="configuration.questionCount"
                    value={assessmentFormik.values.configuration.questionCount}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.configuration?.questionCount && Boolean(assessmentFormik.errors.configuration?.questionCount)}
                    helperText={assessmentFormik.touched.configuration?.questionCount && assessmentFormik.errors.configuration?.questionCount}
                    slotProps={{ htmlInput: { min: 1, max: 100 } }}
                    required
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                  <TextField
                    fullWidth
                    label="Time Limit (minutes)"
                    type="number"
                    name="configuration.timeLimit"
                    value={assessmentFormik.values.configuration.timeLimit}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.configuration?.timeLimit && Boolean(assessmentFormik.errors.configuration?.timeLimit)}
                    helperText={assessmentFormik.touched.configuration?.timeLimit && assessmentFormik.errors.configuration?.timeLimit}
                    slotProps={{ htmlInput: { min: 1, max: 300 } }}
                    required
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                  <TextField
                    fullWidth
                    label="Pass Criteria (%)"
                    type="number"
                    name="configuration.passCriteria"
                    value={assessmentFormik.values.configuration.passCriteria}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.configuration?.passCriteria && Boolean(assessmentFormik.errors.configuration?.passCriteria)}
                    helperText={assessmentFormik.touched.configuration?.passCriteria && assessmentFormik.errors.configuration?.passCriteria}
                    slotProps={{ htmlInput: { min: 1, max: 100 } }}
                    required
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    select
                    size="small"
                    label="Question Order"
                    name="configuration.questionOrder"
                    value={assessmentFormik.values.configuration.questionOrder}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.configuration?.questionOrder && Boolean(assessmentFormik.errors.configuration?.questionOrder)}
                    helperText={assessmentFormik.touched.configuration?.questionOrder && assessmentFormik.errors.configuration?.questionOrder}
                    variant="outlined"
                    required
                  >
                    <MenuItem value="random">Random</MenuItem>
                    <MenuItem value="sequential">Sequential</MenuItem>
                  </TextField>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    label="Max Attempts"
                    type="number"
                    name="configuration.retakePolicy.maxAttempts"
                    value={assessmentFormik.values.configuration.retakePolicy.maxAttempts}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.configuration?.retakePolicy?.maxAttempts && Boolean(assessmentFormik.errors.configuration?.retakePolicy?.maxAttempts)}
                    helperText={assessmentFormik.touched.configuration?.retakePolicy?.maxAttempts && assessmentFormik.errors.configuration?.retakePolicy?.maxAttempts}
                    slotProps={{ htmlInput: { min: 1, max: 10 } }}
                    required
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    label="Waiting Period (hours)"
                    type="number"
                    name="configuration.retakePolicy.waitingPeriod"
                    value={assessmentFormik.values.configuration.retakePolicy.waitingPeriod}
                    onChange={assessmentFormik.handleChange}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.configuration?.retakePolicy?.waitingPeriod && Boolean(assessmentFormik.errors.configuration?.retakePolicy?.waitingPeriod)}
                    helperText={assessmentFormik.touched.configuration?.retakePolicy?.waitingPeriod && assessmentFormik.errors.configuration?.retakePolicy?.waitingPeriod}
                    slotProps={{ htmlInput: { min: 0, max: 168 } }}
                    required
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField
                    fullWidth
                    select
                    size="small"
                    label="Allow Retakes"
                    name="configuration.retakePolicy.allowRetakes"
                    value={assessmentFormik.values.configuration.retakePolicy.allowRetakes ? 'yes' : 'no'}
                    onChange={(e) => {
                      assessmentFormik.setFieldValue('configuration.retakePolicy.allowRetakes', e.target.value === 'yes');
                    }}
                    onBlur={assessmentFormik.handleBlur}
                    error={assessmentFormik.touched.configuration?.retakePolicy?.allowRetakes && Boolean(assessmentFormik.errors.configuration?.retakePolicy?.allowRetakes)}
                    helperText={assessmentFormik.touched.configuration?.retakePolicy?.allowRetakes && assessmentFormik.errors.configuration?.retakePolicy?.allowRetakes}
                    variant="outlined"
                    required
                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
          {/* </form> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          variant="contained" 
          // type="submit"
          onClick={(e:any)=> assessmentFormik.handleSubmit(e)}
          form="assessment-form"
          disabled={!assessmentFormik.isValid || assessmentFormik.isSubmitting}
        >
          {isEditMode ? 'Update' : 'Create'} Assessment
        </Button>
      </DialogActions>
    </Dialog>
  );
};